import { inject, Injectable } from '@angular/core';
import { ApiUsuarioService } from './api-usuario.service';

@Injectable({
  providedIn: 'root'
})
export class CentralAtendimentoService {
  private readonly apiUsuario = inject(ApiUsuarioService);
  private readonly centralUrl = 'https://suporte.agger.com.br';
  private readonly centralLoader = `<!doctypehtml><html lang="pt-BR"><meta charset="UTF-8"><title>Redirecionando...</title><style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;background-color:#fff;padding:24px}.container{display:flex;flex-direction:column;align-items:flex-start;gap:20px}.logo{height:48px;width:auto}.status-container{display:flex;align-items:center;gap:12px}.spinner{width:20px;height:20px;border:3px solid #e2e8f0;border-top:3px solid #002b49;border-radius:50%;animation:spin .8s linear infinite}.message{font-size:15px;font-weight:500;color:#1a202c}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style><div class="container"><img alt="Agger"class="logo"src="https://img.agger.com.br/assets/logo/logo-agger-evertec-preferencial.png"><div class="status-container"><div class="spinner"></div><span class="message">Redirecionando para a Central de Atendimentos...</span></div></div>`;

  public async abrirCentral(): Promise<void> {
    let newWindow = window.open('about:blank', '_blank');

    if (newWindow) {
      newWindow.document.write(this.centralLoader);
      newWindow.document.close();
    }

    let targetUrl = this.centralUrl;

    try {
      const newCentral = await this.apiUsuario.newCentralAuth();

      if (newCentral?.authenticated && newCentral?.url) {
        targetUrl = newCentral.url;
      }
    } catch (error) {
      console.error('Falha ao autenticar na central. Redirecionando para fallback...', error);
    } finally {
      this.redirecionar(newWindow, targetUrl);
    }
  }

  private redirecionar(win: Window | null, url: string): void {
    if (win) {
      win.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  }
}
